import React, { useState } from 'react';
import { markQuickProductsAfterUpload } from '../../../utils/quickProductQueue';
import api from '../../../utils/api';
import styles from './productTable.module.css';
import { CloseProd, Downarrow, Leaf, Pdf, Uparrow } from '../../../Svg';
import { Close } from '@mui/icons-material';
import { BulkUploadProductThunk, deleteProduct, setBulkUploadData } from '../../../redux/productSlice';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { stripHtmlTags } from '../../../utils/fomateDate';
const BulkProdTable = ({ bulkUploadData, loading }) => {

    const dispatch = useDispatch()
    const navigate = useNavigate()
    const { uploadProgress } = useSelector((state) => state.products);

    const allAttributeKeys = Array.from(
        new Set(bulkUploadData?.flatMap(product => Object.keys(product?.attributes || {})))
    );

    const allEnvironmentalKeys = Array.from(
        new Set(bulkUploadData?.flatMap(product => Object.keys(product?.environmental || {})))
    );

    const allAdditionalResources = Array.from(
        new Set(bulkUploadData?.flatMap(product => Object.keys(product?.additionalResources || {})))
    );



    const [currentPage, setCurrentPage] = useState(1);
    const pageSize = 50;

    const totalProducts = bulkUploadData?.length || 0;
    const totalPages = Math.ceil(totalProducts / pageSize);

    const paginatedProducts = bulkUploadData?.slice(
        (currentPage - 1) * pageSize,
        currentPage * pageSize
    );

    const uplaodProduct = async () => {
        const actionResult = await dispatch(BulkUploadProductThunk(bulkUploadData));
        if (!actionResult.error) {
            // Quick products sent here move to "Uploaded to catalog" only when every product went through
            if (!actionResult.payload?.failedCount) {
                await markQuickProductsAfterUpload(api, bulkUploadData);
            }
            dispatch(setBulkUploadData([]));
            navigate('/products/allProduct');
        }
    }


    console.log("sss", bulkUploadData);


    if (bulkUploadData?.length <= 0) {
        return (
            <div>No Product found</div>
        )
    }


    return (
        <>
            <div className={styles.parentContainer}>
                <div className={styles.tableWrapper} style={{ border: "none" }}>
                    <table className={styles.productTable}>
                        <thead className={styles.productTableHead}>
                            <tr>
                                <th className={styles.compare}>Sl No</th>
                                <th className={styles.dataSheet}>Data sheet</th>
                                <th className={styles.partNumber}>
                                    <div className={styles.headerWithFilter}>
                                        <span>Part </span>
                                        <div className={styles.sortIcons}>
                                            <Uparrow />
                                            <Downarrow />
                                        </div>
                                    </div>
                                </th>
                                <th className={styles.manufacturer}>
                                    <div className={styles.headerWithFilter}>
                                        <span>Manufacturer</span>
                                        <div className={styles.sortIcons}>
                                            <Uparrow />
                                            <Downarrow />
                                        </div>
                                    </div>
                                </th>
                                {/* <th className={styles.matchType}>Product Number</th> */}
                                <th className={styles.stock}>
                                    <div className={styles.headerWithFilter}>
                                        <span>Available Stock</span>
                                        <div className={styles.sortIcons}>
                                            <Uparrow />
                                            <Downarrow />
                                        </div>
                                    </div>
                                </th>
                                <th className={styles.unitPrice}>Price</th>
                                <th className={styles.packageType}>Category</th>
                                <th className={styles.packageType}>Alternate Products</th>
                                <th className={styles.packageType}>RoHS</th>
                                {allAttributeKeys?.map((key) => (
                                    <th className={styles.packageType} key={key}>{key}</th>
                                ))}
                                {allEnvironmentalKeys?.map((key) => (
                                    <th className={styles.packageType} key={key}>{key}</th>
                                ))}
                                {allAdditionalResources?.map((key) => (
                                    <th className={styles.packageType} key={key}>{key}</th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {paginatedProducts?.map((product, index) => {
                                const globalIndex = (currentPage - 1) * pageSize + index + 1;
                                return (
                                <tr key={product["Serial No"] || globalIndex}>
                                    <td className={`${styles.compare}  ${styles.tdBorder}`}>
                                        <div style={{ display: 'flex', gap: '26px', marginTop: '20px' }}>
                                            <div onClick={() => dispatch(deleteProduct(product["Serial No"]))}>

                                                <CloseProd />
                                            </div>
                                            <div>
                                                {globalIndex}
                                            </div>
                                        </div>
                                    </td>
                                    <td className={`${styles.dataSheet}  ${styles.tdBorder}`}>
                                        <div className={styles.dataCol}>
                                            <Pdf />
                                            <Leaf />
                                        </div>
                                    </td>
                                    <td className={`${styles.partNumber}  ${styles.tdBorder}`}>
                                        <div className={styles.dataRow}>
                                            <img src={product?.assets?.featuredImage} style={{ width: 30, height: 30 }} alt="" />
                                            <div className={styles.dataCol}>
                                                 <div className={styles.dataColorChange}>{product?.productOverview?.productNumber}</div>
                                                 <div>{stripHtmlTags(product?.productOverview?.description?.[0])}</div>
                                            </div>
                                        </div>
                                    </td>
                                    <td className={`${styles.manufacturer}  ${styles.tdBorder}`}>
                                        <a href={product.manufacturerUrl} className={styles.manufacturer}>
                                            <div className={styles.dataColorChange}> {product?.productOverview?.manufacturer[0]}</div>
                                        </a>
                                    </td>
                                    {/* <td className={`${styles.matchType} ${styles.tdBorder}`}>
                                        {product?.productOverview?.productNumber[0]}
                                    </td> */}
                                    <td className={`${styles.stock}  ${styles.tdBorder}`}>
                                        {product?.inventory?.qtyAvailable}
                                        <div className={styles.dataMargin}>in stock</div>
                                        {product?.inventory?.factoryStock ?
                                            <>
                                                {product?.inventory?.factoryStock}
                                                <div className={styles.dataMargin}>factoryStock</div>
                                            </>
                                            : null}
                                        <div>CanShip Immediately: {product?.inventory?.canShipImmediately ? 'YES' : 'NO'}</div>
                                    </td>
                                    <td className={`${styles.unitPrice}  ${styles.tdBorder}`}>
                                        {product?.quantityTable?.map((i, idx) => (
                                            <React.Fragment key={idx}>
                                                <div className={styles.dataMargin}>{i?.breakQty}: ₹{i?.unitPrice} {i?.packaging}</div>
                                            </React.Fragment>
                                        ))
                                        }
                                    </td>
                                    <td className={`${styles.packageType}  ${styles.tdBorder}`}>
                                        {product?.categories?.map((i, idx) => (
                                            <div key={idx}>
                                                {i}
                                            </div>
                                        ))}
                                    </td>

                                    <td className={`${styles.packageType}  ${styles.tdBorder}`}>
                                        {product?.alternateProducts?.map((i, idx) => (
                                            <div key={idx}>
                                                {i}
                                            </div>
                                        ))}
                                    </td>
                                    <td className={`${styles.packageType}  ${styles.tdBorder}`}>
                                       {product?.RoHS}
                                    </td>

                                    {allAttributeKeys?.map((key) => (
                                        <td key={key} className={`${styles.packageType}  ${styles.tdBorder}`}>
                                            {product.attributes[key]?.join(", ") || "N/A"}
                                        </td>
                                    ))}

                                    {allEnvironmentalKeys?.map((key) => (
                                        <td key={key} className={`${styles.packageType}  ${styles.tdBorder}`}>
                                            {product?.environmental[key]?.join(", ") || "N/A"}
                                        </td>
                                    ))}

                                    {allAdditionalResources?.map((key) => (
                                        <td key={key} className={`${styles.packageType}  ${styles.tdBorder}`}>
                                            {product?.additionalResources[key]?.join(", ") || "N/A"}
                                        </td>
                                    ))}

                                </tr>
                            );
                            })}
                        </tbody>


                    </table>
                </div>
            </div>
            {totalPages > 1 && (
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', margin: '15px 30px' }}>
                    <div style={{ fontSize: '14px', fontWeight: '500', color: '#555' }}>
                        Total Products Loaded: <strong>{totalProducts}</strong> | Page {currentPage} of {totalPages}
                    </div>
                    <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                        <button
                            onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                            disabled={currentPage === 1 || loading}
                            style={{ padding: '6px 16px', borderRadius: '4px', cursor: currentPage === 1 ? 'not-allowed' : 'pointer' }}
                        >
                            Previous
                        </button>
                        <span style={{ fontSize: '14px', fontWeight: '500' }}>{currentPage} / {totalPages}</span>
                        <button
                            onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                            disabled={currentPage === totalPages || loading}
                            style={{ padding: '6px 16px', borderRadius: '4px', cursor: currentPage === totalPages ? 'not-allowed' : 'pointer' }}
                        >
                            Next
                        </button>
                    </div>
                </div>
            )}
            <div className={styles.displayFlex} style={{justifyContent:"center"}}>
                <button className={styles.cancelBtn} onClick={() => navigate('/products/allProduct')} disabled={loading}>Cancel</button>
                <button
                    className={styles.submitBtn}
                    onClick={uplaodProduct}
                    disabled={loading}
                >
                    {loading
                        ? uploadProgress?.total > 0
                            ? `Uploading... ${uploadProgress.current}/${uploadProgress.total} (${Math.round((uploadProgress.current / uploadProgress.total) * 100)}%)`
                            : 'please wait...'
                        : `Approve & submit (${totalProducts} products)`}
                </button>
            </div>
        </>
    );
};

export default BulkProdTable;
